import { reduxForm, SubmissionError } from "redux-form";
import * as actions from "../constants/actions";
import PasswordResetForm from "../components/forms/PasswordResetForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.resetPassword({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

export default reduxForm({
  form: "passwordReset",
  onSubmit
})(PasswordResetForm);



// WEBPACK FOOTER //
// ./src/containers/PasswordResetForm.js